import { PencilIcon, TrashIcon, UserPlusIcon } from "@heroicons/react/20/solid";
import Typography from "components/elements/Typography";
import ContributorBadge from "components/pages/ProfessionalSpace/components/ContributorBadge";
import ProjectTeamRoleContributorsResponseResource from "common/resources/Project/Config/Team/Role/ProjectTeamRoleContributorsResponseResource";
import { translateISO369 } from "utils/I18nText";
import classes from "./classes.module.scss";
import { useContributor } from "components/pages/ProfessionalSpace/hooks/useContributor";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";

type IProps = {
	roles: ProjectTeamRoleContributorsResponseResource[];
	isEditing?: boolean;
	onAddContributor?: (role: ProjectTeamRoleContributorsResponseResource) => void;
	onEditRole?: (role: ProjectTeamRoleContributorsResponseResource) => void;
	onDeleteRole?: (role: ProjectTeamRoleContributorsResponseResource) => void;
};

function RoleContributorBadge(props: { contributor: ContributorResponseResource }) {
	const { avatarUrl } = useContributor(props.contributor);
	return <ContributorBadge contributor={props.contributor} avatarUrl={avatarUrl} />;
}

export default function Roles(props: IProps) {
	return (
		<div className={classes["root"]}>
			{props.roles
				.sort((a, b) => a.index - b.index)
				.map((role) => (
					<div key={role.id} className={classes["role-container"]}>
						<div className={classes["role"]}>
							<Typography type="p" weight="medium" className={classes["role-title"]}>
								{translateISO369(role.roleTitle)} :
							</Typography>

							<div className={classes["contributors"]}>
								{role.contributors.map((contributor) => (
									<RoleContributorBadge key={contributor.id} contributor={contributor} />
								))}
							</div>
						</div>

						{props.isEditing && (
							<div className={classes["buttons-container"]}>
								<UserPlusIcon className={classes["icon"]} onClick={() => props.onAddContributor?.(role)} />
								<PencilIcon className={classes["icon"]} onClick={() => props.onEditRole?.(role)} />
								<TrashIcon className={classes["icon"]} onClick={() => props.onDeleteRole?.(role)} />
							</div>
						)}
					</div>
				))}
		</div>
	);
}
